import React from "react";
import ReactDOM from "react-dom/client"; // 使用 React 18 的新 API
import App from "./App";
import { GoogleOAuthProvider } from "@react-oauth/google";
import reportWebVitals from "./reportWebVitals";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root")); // 使用 createRoot 而不是 render

root.render(
  <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
    <App />
  </GoogleOAuthProvider>
);

// 性能測量代碼
reportWebVitals();
